<template>
    <v-navigation-drawer
        v-model="drawer"
        :color="theming.sideBarColor || 'ffffff'"
        fixed
        :permanent="shouldDrawerBePermanent"
        class="drawer pt-14"
        :width="drawer? '190px' : '60px'"
    >
        <v-list
            nav
            dense
        >
            <div v-for="(menuItem, index) in menu" :key="index" @click="setDrawer">
                <v-list-item v-if="((!menuItem.roles || containsAny(menuItem.roles, userRoles)) && menuItem.show !== false)" :to="menuItem.to" link>
                    <v-list-item-icon v-if="menuItem.icon" class="mr-3 mb-3 mt-3">
                        <v-icon :color="menuItem.color ? menuItem.color : 'grey'">{{ menuItem.icon }}</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title v-if="menuItem.title" :color="theming.sideBarText || 'black'"><span class="menu-item">{{ menuItem.title }}</span></v-list-item-title>
                </v-list-item>
            </div>
        </v-list>
        <template v-if="drawer" v-slot:append>
            <div class="powered-by-wrapper" :color="theming.sideBarText || 'black'">
                <span class="powered-by">
                    developed by
                </span>
                <span class="powered-by-name" @click="onNameClick">
                    Karageorgos Dimitris
                </span>
            </div>
        </template>
    </v-navigation-drawer>
</template>

<script>
    import jwtUtil from '@/utils/jwtUtil'
    export default {
        name: 'Sidebar',
        data() {
            return {
                menu: [
                    {
                        title: 'Αναθέσεις',
                        to: '/assignments',
                        icon: 'mdi-clipboard-arrow-down-outline',
                        color: '#0047AB'
                    },
                    {
                        title: 'Στατιστικά',
                        to: '/stats',
                        icon: 'mdi-finance',
                        color: 'green',
                        roles: ['ROLE_ADMIN']
                    },
                    {
                        title: 'Χρήστες',
                        to: '/users',
                        color: '#FFC000',
                        icon: 'mdi-account-multiple-outline',
                        roles: ['ROLE_ADMIN', 'ROLE_CONTRACTOR']
                    },
                    {
                        title: 'Αποθήκη',
                        to: '/storage',
                        color: '#9F2B68',
                        icon: 'mdi-warehouse',
                        roles: ['ROLE_ADMIN'],
                        show: false
                    },
                    {
                        title: 'Καμπίνες',
                        to: '/cabins',
                        color: '#A47DAB',
                        icon: 'mdi-file-cabinet',
                        show: false
                    },
                    {
                        title: 'Ημερολόγιο',
                        to: '/calendar',
                        icon: 'mdi-calendar',
                        color: 'grey',
                        show: false
                    }
                ],
                width: 0,
                height: 0
            }
        },
        watch: {
            config: {
                handler(newVal, oldVal) {
                    if (!newVal) {
                        return
                    }
                    if (newVal.hasStorage) {
                        const item = this.menu.find(menuItem => menuItem.to === '/storage')
                        item.show = true
                    }
                    if (newVal.hasCalendar) {
                        const item = this.menu.find(menuItem => menuItem.to === '/calendar')
                        item.show = true
                    }
                    if (newVal.hasCabins) {
                        const item = this.menu.find(menuItem => menuItem.to === '/cabins')
                        item.show = true
                    }
                    this.menu = [ ...this.menu ]
                },
                immediate: true
            }
        },
        computed: {
            config() {
                return this.$store.getters.getConfig || {}
            },
            theming() {
                return this.$store.getters.getTheming || {}
            },
            drawer: {
                get() {
                    return this.$store.getters.getDrawer
                },
                set(value) {
                    return value
                }
            },
            userRoles() {
                return jwtUtil.getRoles(this.$store.getters.getToken) || []
            },
            shouldDrawerBePermanent() {
                if (this.width < 950) {
                    return false
                }
                return true
            }
        },
        mounted() {
            this.width = window.innerWidth
            this.height = window.innerHeight
            window.addEventListener('resize', this.onScreenResize)
        },
        methods: {
            onNameClick() {
                window.open('https://karageorgos-dimitris.com', '_blank').focus()
            },
            onScreenResize() {
                this.width = window.innerWidth
                this.height = window.innerHeight
            },
            containsAny(arr1, arr2) {
                return arr1.some(item => arr2.includes(item))
            },
            setDrawer() {
                this.$store.dispatch('setDrawer', !this.drawer)
            },
            include() {
                return [document.querySelector('.included')]
            }
        }
    }
</script>

<style scoped>
.drawer {
    box-shadow: 0px 4px 6px rgba(0,0,0,0.1);
    background: linear-gradient(to bottom, var(--sidebar-color), color-mix(in srgb, var(--sidebar-color) 85%, black));
}
a {
    color: #0060B6;
    text-decoration: none;
}

a:hover {
    color:#00A0C6;
    text-decoration:none;
    cursor:pointer;
}
.sub-text{
    font-size: 0.8rem;
    color: black;
}
.container {
    align-self: center;
    height: 100%;
}

.menu-item {
    font-size: 1rem;
    color: var(--sidebar-text-color);
}

.powered-by-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.powered-by {
    font-size: 0.7rem;
    color: var(--sidebar-text-color);
    padding-right: 3.7rem;
}

.powered-by-name {
    font-size: 0.85rem;
    color: var(--sidebar-text-color);
    cursor: pointer;
}

.powered-by-name:hover {
    color: #01aebe
}
</style>
